import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"

const LogoutUser = ({ logOut, SetAlign }) => {
    const navigate = useNavigate()
    const [RefreshUrl, SetRefreshUrl] = useState("/login")
    const logoutUser = () => {
        // localStorage.clear();

        localStorage.removeItem("conserve_authtoken")
        localStorage.removeItem("auth_token")
        localStorage.setItem("checkAuth", JSON.stringify(""));
        // localStorage.removeItem("TrustDeviceDate")
        // localStorage.removeItem("remember30Days")
        navigate(RefreshUrl)
        // setTimeout(() => {
        //     window.location.reload();
        // }, 200);
    }
    return (
        <React.Fragment>
            <div style={{ display: `${SetAlign ? "initial" : "flex"}`, gap: "12px", justifyContent: "center" }} onClick={() => logoutUser()} className={`${logOut != "admin" ? "header_lougout" : ""}`}>
                {/* {logOut == "admin" && (
                    <button className="logout flex flex-col items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 8L22 12M22 12L18 16M22 12H9M15 4.20404C13.7252 3.43827 12.2452 3 10.6667 3C5.8802 3 2 7.02944 2 12C2 16.9706 5.8802 21 10.6667 21C12.2452 21 13.7252 20.5617 15 19.796" stroke="#5786CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                )} */}
                {/* {logOut == "dropdownLogout" && (
                    <React.Fragment>
                        <span >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5.333 14.667 8m0 0L12 10.667M14.667 8H6m4-5.197A5.589 5.589 0 0 0 7.11 2C3.92 2 1.333 4.686 1.333 8s2.587 6 5.778 6c1.052 0 2.04-.292 2.889-.803" stroke="#344054" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span
                            onClick={() => {

                            }}
                            className="text-xs text-gray-700 font-medium"
                        >
                            Log Out
                        </span>

                    </React.Fragment>
                )
                } */}
                {/* {logOut == "client" && ( */}
                    <button className="logout_btn flex items-center gap-3 p-3 rounded-lg bg-[#FF8E1C] text-white ">
                        <span className="icons-wrap"><svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 6L17 9M17 9L14 12M17 9H7.25M11.75 3.15303C10.7939 2.57871 9.68393 2.25 8.5 2.25C4.91015 2.25 2 5.27208 2 9C2 12.7279 4.91015 15.75 8.5 15.75C9.68393 15.75 10.7939 15.4213 11.75 14.847" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
                        <span className="text-wrap text-center">Logout</span>
                    </button>
                {/* )} */}
            </div>

        </React.Fragment>
    )
}
export default LogoutUser